export default __webpack_public_path__ + "static/media/remove-user.cefb1d0f.svg";